export default __webpack_public_path__ + "static/media/self-paced.d0ef72a9.svg";